import http from './http';

export function getInstitutionExportUsers(institutionId, params = {}) {
	return http
		.get(`/admin/unilogin/institution/${institutionId}/export/users`, { params })
		.then(resp => resp.data);
}

export function getInstitutionExportGroups(institutionId, params = {}) {
	return http
		.get(`/admin/unilogin/institution/${institutionId}/export/groups`, { params })
		.then(resp => resp.data);
}

export function getInstitutionExportLogs(institutionId) {
	return http.get(`/admin/unilogin/institution/${institutionId}/export/logs`).then(resp => resp.data);
}

export function queueInstitutionExport(institutionId) {
	return http.post(`/admin/unilogin/institution/${institutionId}/export/queue`).then(resp => resp.data);
}

export function getInstitution(institutionId) {
	return http.get(`/admin/unilogin/institution/${institutionId}`).then(resp => resp.data);
}
